const hidden = {
  visibility: 'hidden',
  margin: 'unset',
  padding: 'unset',
  height: '0',
};

module.exports = { hidden };
